import { useLocation } from "react-router-dom";
import useAnalytics from "../../hooks/useAnalytics.js";
import { getAnalyticsContext } from "../../utils/analytics.js";

const SiteAnalyticsTracker = () => {
  const { pathname } = useLocation();
  const { pageName, publicationId } = getAnalyticsContext(pathname);

  useAnalytics({
    page: pageName,
    publicationId,
    trackingKey: pathname,
  });

  return null;
};

export default SiteAnalyticsTracker;
